// Imports
  // React
  import { useEffect, useState } from 'react'
  import { useParams, useNavigate } from 'react-router-dom'
  // Firebase
  import "../firebase/FirebaseClient"
  import { getCombosById } from '../firebase/FirebaseClient'
  //Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faXmark } from "@fortawesome/free-solid-svg-icons"




// rafce
const CombosCardDescription = ( ) => {

    const {id} = useParams()
    const navigate = useNavigate()

    const [item, setItem] = useState("")

    // Get combo from Firestore
    useEffect(() => {
        getCombosById(id).then( data => {
            setItem(data)
        })
    }, [])

    //Component
    return (
        <div className='combos-description'>
            <p>{item.description}</p>
            <button onClick={() => navigate(-1)}>
                <FontAwesomeIcon icon={ faXmark } />
            </button>
        </div>
    )

}

export default CombosCardDescription

